// ============================================================
// validate.js
// ------------------------------------------------------------
// ตรวจความครบถ้วนของฟอร์มก่อนบันทึก
// ============================================================

import React from "react";
import { alert } from "./alert.js";

// เครื่องหมาย * สีแดง สำหรับกำกับช่องที่บังคับกรอก
export const required = <span className="text-danger mx-1">*</span>;

// เช็คว่า field ที่บังคับกรอกใน state ว่างไหม
// ใช้: if (validate(this.state, ["full_name", "phone_number"])) return;
// คืน true = มีช่องว่าง (เด้ง popup ให้แล้ว) ให้หน้าจอหยุดทำงานต่อ
export const validate = (state, validate) => {
  for (let v of validate) {
    if (state[v] === "" || state[v] === null || (state[v] && state[v].length === 0)) {
      alert("warning", "แจ้งเตือน", "กรุณากรอกข้อมูลให้ครบถ้วน");
      return true;
    }
  }
  return false;
};
